// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-role-new-layout {
  height: 100%;
}
.fi-role-new-layout .layout-container {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/role/role-new-layout/role-new-layout.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,YAAA;AACR","sourcesContent":[".fi-role-new-layout {\r\n    height: 100%;\r\n\r\n    .layout-container {\r\n        height: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
